module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Thank":"Votre commande a été transmis, nous vous remercions vivement."},"en":{"Thank":"Your order has been transmitted, we thank you very much."}}')
  delete Component.options._Ctor
}
